import { defineStore } from 'pinia';
import axios from 'axios';
import { useToast } from 'primevue/usetoast';

export const useNotificationStore = defineStore('notifications', {
  state: () => ({
    notifications: [],
    unreadCount: 0
  }),

  actions: {
    async fetchNotifications() {
      try {
        const response = await axios.get(
          '/notifications/getunreadnotifications'
        );
        this.notifications = response.data;
        this.unreadCount = this.notifications.length;

        if ('setAppBadge' in navigator) {
          if (this.unreadCount === 0) {
            navigator.clearAppBadge();
          } else {
            navigator.setAppBadge(this.unreadCount);
          }
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
        /*
        const toast = useToast();
        toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch notifications',
          life: 3000
        });
        */
      }
    },

    async toggleReadStatus(notification) {
      try {
        await axios.post('/notifications/markasreadbyid', {
          id: notification.id
        });

        const index = this.notifications.findIndex(
          n => n.id === notification.id
        );
        if (index !== -1) {
          this.notifications[index].read_at = new Date();
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        }

        if ('setAppBadge' in navigator) {
          if (this.unreadCount === 0) {
            navigator.clearAppBadge();
          } else {
            navigator.setAppBadge(this.unreadCount);
          }
        }
      } catch (error) {
        console.error('Error marking notification as read:', error);
        const toast = useToast();
        toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to mark notification as read',
          life: 3000
        });
      }
    },
    async handleNewNotification(notification) {
      /*
      this.notifications.unshift(notification);
      this.unreadCount++;
      if ('setAppBadge' in navigator) {
        navigator.setAppBadge(this.unreadCount);
      }
        */
       if(notification.type != 'App\\Notifications\\GigMessageInstant'){
        /*
        const toast = useToast();
        toast.add({
          severity: 'info',
          summary: notification.title,
          detail: notification.message,
          life: 5000
        });
        */
      }
    }
      
  }
});
